/**
 * Attribute helpers - work with attribute types from Redux or localStorage
 */
export const getStoredAttributeTypes = () => {
  try {
    const stored = localStorage.getItem('attributeTypes');
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

export const getAttributesByTypeName = (attributeTypesOrName, typeName) => {
  let list;
  let name;
  if (typeName !== undefined) {
    list = Array.isArray(attributeTypesOrName) ? attributeTypesOrName : getStoredAttributeTypes();
    name = typeName;
  } else {
    list = getStoredAttributeTypes();
    name = attributeTypesOrName;
  }
  const type = list.find((t) => t.name && t.name.toLowerCase() === (name || '').toLowerCase());
  return type?.attributes ?? [];
};
